import { render, staticRenderFns } from "./PerformanceContent.vue?vue&type=template&id=34f996f6"
import script from "./PerformanceContent.vue?vue&type=script&lang=js"
export * from "./PerformanceContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports